import { Search, AlertCircle, Home } from "lucide-react";
import { useState, useEffect } from "react";

export const FourOhFour = () => {
  return (
    <>
      <div className="bg-background -mt-[72px] h-[72px]"></div>
      <div className="bg-background min-h-screen flex items-center justify-center">
        <div className="max-w-md w-full px-6 py-12 text-center">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <AlertCircle
                className="text-primary w-16 h-16 animate-pulse"
                aria-hidden="true"
              />
            </div>
            <span className="sr-only">404 error icon</span>
          </div>
          <h1 className="text-6xl font-bold text-primary mb-6">404</h1>
          <h2 className="text-xl text-foreground mb-8">
            The page you are looking for could not be found
          </h2>
          <p className="text-muted-foreground mb-8">
            The page may have been moved, deleted, or never existed.
          </p>
          <a
            href="/app/dashboard"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            <Home className="w-4 h-4 mr-2 animate-bounce" />
            Return to Dashboard
          </a>
        </div>
      </div>
    </>
  );
};
